<app-userlist [avatars]="avatars"></app-userlist>
<div class="dialog">
  <div class="dialog__type-indicator"
       [ngClass]="{
         'dialog__type-indicator--epic': (issue.issueType === 0),
          'dialog__type-indicator--story': (issue.issueType === 1),
          'dialog__type-indicator--task': (issue.issueType === 2),
          'dialog__type-indicator--bug': (issue.issueType === 3),
          'dialog__type-indicator--subissue': (issue.isSubissue)
       }">
  </div>
  <div class="dialog__header" [attr.data-issueid]="issue.id">
    <div class="dialog__header-title">
    {{(issue.isSubissue) ? 'Subissue' : 'Issue'}} {{isNewIssue ? 'erstellen' : 'bearbeiten'}}
    <app-unseen-indicator [issue]="issue"></app-unseen-indicator>
  </div>
    <div class="dialog__header-buttons">
      <!-- Buttons for existing issue thats being edited -->
      <button mat-flat-button (click)="openConfirmDeleteDialog($event)" *ngIf="!isNewIssue">
        <mat-icon class="icon icon--primary">delete_outline</mat-icon>
      </button>
      <button mat-flat-button (click)="onDiscardButtonClicked()" id='discard-changes' *ngIf="!isNewIssue">
        <mat-icon class="icon icon--primary">close</mat-icon>
      </button>
      <button mat-flat-button [disabled]="!(issueHasBeenChanged && formIsValid)" (click)="closeThisCard()" *ngIf="!isNewIssue">
        <mat-icon [ngClass]="((issueHasBeenChanged && formIsValid)) ? 'icon icon--primary' : 'icon icon--disabled'">done</mat-icon>
      </button>

      <!-- Buttons for new issue not yet persisted -->
      <button mat-flat-button (click)="onDiscardButtonClicked()" *ngIf="isNewIssue">
        <mat-icon class="icon icon--primary">close</mat-icon>
      </button>
      <button mat-flat-button [disabled]="!(issueHasBeenChanged && formIsValid)" (click)="confirmNewIssueCreation()" *ngIf="isNewIssue">
        <mat-icon [ngClass]="((issueHasBeenChanged && formIsValid)) ? 'icon icon--primary' : 'icon icon--disabled'">done</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog__section">
    <!--Title-->
    <div class="dialog__field">
      <label for="dialog-title" class="dialog__label">Title*</label>
      <input type="text" id="dialog-title" class="dialog__input"
             [value]="this.issue.summary"
             (input)="issueTitleChanged($event)"
             placeholder="add a Title..."
             #dialogTitle>
      <p class="dialog__msg dialog__msg--error" *ngIf="titleMsg">{{titleMsg}}</p>
    </div>
    <!--Last Update-->
    <app-last-updated [issue]="issue" [isCardView]="true"></app-last-updated>
    <!--Description-->
    <div class="dialog__field">
      <label for="dialog-description" class="dialog__label">Description</label>
      <!-- TODO use translation for placeholder-text -->
      <textarea id="dialog-description" class="dialog__input"
                [value]="this.issue.description"
                (input)="issueDescriptionChanged($event)"
                placeholder="add a Description...">
      </textarea>
    </div>
    <!-- Status -->
    <div class="dialog__field" *ngIf="this.statuses">
      <label for="dialog-status" class="dialog__label">Status</label>
      <div class="dropdown">
        <select id="dialog-status" class="dropdown__select" (change)="issueStatusChanged($event)">
          <ng-container>
            <option class="dropdown__item"
                    *ngFor="let status of this.statuses"
                    [value]="status.id"
                    [selected]="status.id === issue.status.id">
              {{status.name}}
            </option>
          </ng-container>
        </select>
        <div class="dropdown__icon">
          <i class="material-icons">keyboard_arrow_down</i>
        </div>
      </div>
    </div>
    <!-- IssueType -->
    <div class="dialog__field" *ngIf="!this.issue.isSubissue">
      <label for="dialog-status" class="dialog__label">Type</label>
      <div class="dropdown">
        <select class="dropdown__select issue-type" (change)="issueTypeChanged($event)">
          <option class="dropdown__item" *ngFor="let issueTypeKey of this.availableIssueTypeKeys"
            [value]="issueTypeEnum[issueTypeKey]" [selected]="issueTypeEnum[issueTypeKey] === issue.issueType">
              {{issueTypeKey.toLowerCase()}}
          </option>
        </select>

        <div class="dropdown__icon">
          <i class="material-icons">keyboard_arrow_down</i>
        </div>
      </div>
    </div>
    <!-- Storypoints, appears only in Parent-Issues of Type Story -->
    <!-- The persisted type (originalIssue) must be Story in order to set Points (User must persist type-change first) -->
    <div class="dialog__field" *ngIf="!this.issue.isSubissue
      && (this.issue.issueType === issueTypeEnum.USERSTORY)
      && (this.originalIssue.issueType === issueTypeEnum.USERSTORY)">
      <label for="storypoints" class="dialog__label">Storypoints</label>
      <div class="dropdown">
        <select id="storypoints" class="dropdown__select" (change)="issueStoryPointsChanged($event)">
          <option class="dropdown__item"
                  *ngFor="let option of storyPointsOptions"
                  [value]="option"
                  [selected]="option === this.issue.storyPoints">
            {{option}}
          </option>
        </select>

        <div class="dropdown__icon">
          <i class="material-icons">keyboard_arrow_down</i>
        </div>
      </div>
    </div>
  </div> <!--End text-dropdown-wrapper-->

  <div class="dialog__section">
    <!--Assignee-->
    <div class="dialog__field assignee">
      <div class="dialog__label">Assignee
      </div>
      <div class="assignment-field assignment-field--person person-dropzone assignee teamwidgetdropzone"
        [attr.data-issueid]="issue.id"
        [attr.data-projectkey]="projectKey">
        <div class="assignment-field__icon assignment-field__icon--person">
          <img *ngIf="this.issue.assignee" class="avatar" [src]="'data:image/png;base64,'+ this.issue.assignee.avatarImage">
          <i *ngIf="!this.issue.assignee" class="material-icons">person</i>
        </div>
        <div class="assignment-field__name">
          <p [ngClass]="this.issue.assignee ? '' : 'assignment-field__hint'">
            {{this.issue.assignee?.displayName || ('components.issuecard.noMemberAssigned' | translate)}}
          </p>
        </div>
        <div class="assignment-field__icon assignment-field__icon--delete" *ngIf="this.issue.assignee" (click)="issueAssigneeChanged(null)">
          <mat-icon *ngIf="this.issue.summary">close</mat-icon>
        </div>
      </div>
    </div>

    <!--Reporter-->
    <div class="dialog__field reporter">
      <div class="dialog__label">Reporter
      </div>
      <div class="assignment-field assignment-field--person person-dropzone reporter teamwidgetdropzone"
        [attr.data-issueid]="issue.id"
        [attr.data-projectkey]="projectKey">
        <div class="assignment-field__icon assignment-field__icon--person">
          <img *ngIf="this.issue.reporter" class="avatar" [src]="'data:image/png;base64,'+ this.issue.reporter.avatarImage">
          <i *ngIf="!this.issue.reporter" class="material-icons">person</i>
        </div>
        <div class="assignee__name">
          <p [ngClass]="this.issue.reporter ? '' : 'assignment-field__hint'">
            {{this.issue.reporter?.displayName || ('components.issuecard.noMemberAssigned' | translate)}}
          </p>
        </div>
      </div>
  </div>

  <!-- Attachements -->
  <div class="dialog__field" [attr.data-issueid]="issue.id" *ngIf="!isNewIssue">
    <div class="dialog__label">Attachements
    </div>
    <div class="assignment-field assignment-field--attachment" *ngFor="let attachment of this.issue.attachments">
      <div class="assignment-field__icon assignment-field__icon--attachment">
        <i class="material-icons">attachment</i>
      </div>
      <div class="attachement__name">
        {{attachment.fileName}}
      </div>
    </div>
  </div>
  </div>

  <!-- Comments -->
  <div class="dialog__field" *ngIf="!isNewIssue && (this.issue.comments && this.issue.comments.length > 0)">
    <div class="dialog__label">Comments</div>

    <div class="dialog__comments">
      <div class="comment" *ngFor="let comment of this.issue.comments">
        <div class="comment__icon">
          <i class="material-icons" id="icon__comment">comment_outline</i>
        </div>
        <div class="comment__headline">
          <div class="comment__name">
            {{comment.author.displayName}}
          </div>
          <div class="comment__date-time">
            {{
              comment.created.toLocaleDateString(
                'de-CH',
                {
                  day: '2-digit',
                  month: 'long',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                }
              )
            }}
          </div>
        </div>
        <div class="comment__content">
          {{comment.content}}
        </div>
      </div>
    </div>
  </div>

  <!-- Stickers -->
  <!-- TODO test and refactor to make stickers work -->
  <!--
  <div class="card-field stickers" *ngIf="!isNewIssue">
    <div class="label"><p>Stickers</p></div>
    <div class="content">
      <span  class="sticker-icon" *ngFor="let sticker of issue.stickers">
        <mat-icon [ngStyle]="{'color': sticker.iconColor}">{{sticker.iconName}}</mat-icon>
        <img *ngIf="sticker.imageData" [src]="sticker.imageData" />
      </span>
    </div>
  </div>
  -->

</div>
